import gql from "graphql-tag";

const GET_RELATED_BLOGS = gql`
    query Blogs($category: String!, $blogID: ID!){
        blogs(limit:10, 
        where: { 
            blog_categories: { category: $category },
            id_ne: $blogID
        }
        
        ){
            id,
            title
            preview{
                url
                formats
            }
        }
    }
`
export default GET_RELATED_BLOGS